import React, { useMemo, useState, useEffect } from 'react'
import styles from "./FormListingFilters.styles";
import SelectDropdown from '../../../../components/dropdown/selectdropdown/SelectDropdown';

import { useDispatch } from 'react-redux';
import { getFormsList, getPayersBySelectedForm, getSubmittedForms, getTaxYears } from '../FormListingSaga';
import { useSelector } from 'react-redux';
import { componentKey, setFillingType, setFormStatus, setFormType, setPaginationState, setRecipientName, setRecipientTIN, setSelectedForm, setSelectedPayer, setSelectedTaxYear, setShouldGetSubmittedFormsGridData, setPayerDropdownPagination } from '../FormListingSlice';
import TextInput from '../../../../components/input/textinput/TextInput';
import { VEC_ICON_NAME } from '../../../../components/icons/constants';
import { FORM_IDS, QUERY_PARAMS } from '../../constants';
import Heading from '../../../../components/heading/Heading';
import { HEADING } from '../../../../components/heading/constants/constants';
import VerticalSeparator from '../../../../components/separator/verticalseparator/VerticalSeparator';
import IconDropdown from '../../../../components/dropdown/icondropdown/IconDropdown';
import useTxSearchParams from '../../../../../libs/txsearchparams/TxSearchParamsHook';

export default function FormListingFilters() {

    const dispatch = useDispatch();
    const [queryParams, setQueryParams] = useTxSearchParams();

    const { formsList, selectedForm, payersList, selectedPayer, fillingType, formType, recipientName, recipientTIN, selectedTaxYear, taxYearsList, payerDropdownPagination } = useSelector(state => state[componentKey]);
    const [paginatedPayerList, setPaginatedPayerList] = useState([]);
    useEffect(() => {
        setPaginatedPayerList(payersList)
    }, [payersList])
    return (
        <>
            <div style={styles.headerText}>
                <Heading type={HEADING.H3} customStyle={styles.viewingYear}>You are currently viewing the forms for</Heading>
            </div>

            <div style={styles.searchFilter}>
                <div style={styles.filter}>
                    <>
                        <div style={styles.filtersContainer}>
                            <SelectDropdown
                                dropdownContainerStyles={styles.filterContainerStyles}
                                label="Form"
                                name="form"
                                placeHolder="Select a form"
                                value={selectedForm}
                                options={formsList.filter(form => form.Id !== FORM_IDS[8809])}
                                onSelectCb={(name, selectedOption) => {
                                    dispatch(setSelectedForm(selectedOption));
                                    dispatch(setSelectedPayer({ label: "", value: "" }))
                                    queryParams.set("PayerId", "");
                                }}
                                isClearable={false}
                            />

                            <SelectDropdown
                                dropdownContainerStyles={styles.filterContainerStyles}
                                label="Tax Year"
                                name="TaxYear"
                                placeHolder="Please select a Tax year"
                                options={taxYearsList}
                                value={selectedTaxYear}
                                onSelectCb={(name, selectedOption) => {
                                    dispatch(setSelectedTaxYear(selectedOption));
                                    queryParams.set("TaxYear", selectedOption?.value);
                                    setQueryParams(queryParams);
                                }}
                                isClearable={false}
                            />

                            <SelectDropdown
                                dropdownContainerStyles={styles.filterContainerStyles}
                                label="Payer"
                                name="Payer"
                                placeHolder="Please select a payer"
                                options={paginatedPayerList.slice(0, payerDropdownPagination.PageSize * (payerDropdownPagination.PageNumber))}
                                onDropdownTouchedToBottomCb={() => {
                                    if (payerDropdownPagination.PageSize * (payerDropdownPagination.PageNumber) < paginatedPayerList?.length) {
                                        dispatch(setPayerDropdownPagination({ PageNumber: payerDropdownPagination.PageNumber + 1 }))
                                    }
                                }}
                                value={selectedPayer}
                                onSelectCb={(name, selectedOption) => dispatch(setSelectedPayer(selectedOption))}
                                isClearable={false}
                            />

                            {/* <Button
                    onClickCb={() => {
                        if (!selectedPayer?.PayerDetailId || !selectedForm?.FormId || !selectedTaxYear?.ID) {
                            dispatch(addNotifications({ heading: "Please select a form, tax year and payer" }))
                        } else {
                            dispatch(setShouldGetSubmittedFormsGridData({
                                gridData: true,
                                updatePagination: true,
                            }))
                        }
                    }}
                    style={styles.createFormBtn}
                >
                    Apply
                </Button> */}

                            {/* <SelectDropdown
                    name="TaxYear"
                    label="Tax Year*"
                    placeHolder="Please select tax year"
                    value={selectedTaxYear}
                    options={taxYearsList}
                    onSelectCb={(name, selectedOption) => dispatch(setSelectedTaxYear(selectedOption))}
                /> */}

                            <SelectDropdown
                                dropdownContainerStyles={styles.filterContainerStyles}
                                name="FormType"
                                label="Form Type"
                                placeHolder="Please select form type"
                                value={formType}
                                options={[{ label: "Regular", value: "" }, { label: "Corrected", value: "G" }]}
                                isClearable={false}
                                onSelectCb={(name, selectedOption) => {
                                    dispatch(setFormType(selectedOption))
                                    dispatch(setShouldGetSubmittedFormsGridData({
                                        gridData: true,
                                        updatePagination: true,
                                    }))

                                    if (selectedOption?.label == "Regular") {
                                        queryParams.set("FormType", "Regular");
                                    } else {
                                        queryParams.set("FormType", "Corrected");
                                    }

                                    setQueryParams(queryParams);
                                }}
                            />

                            {/* <SelectDropdown
                    name="FormStatus"
                    label="Form Status"
                    placeHolder="Please select form status"
                    value={formStatus}
                    options={[{ label: "Not Submitted", value: "NotSubmitted" }, { label: "Approved", value: "Approved" }]}
                    onSelectCb={(name, selectedOption) => dispatch(setFormStatus(selectedOption))}
                /> */}

                            <SelectDropdown
                                dropdownContainerStyles={styles.filterContainerStyles}
                                name="FilingType"
                                label="Filing Type"
                                placeHolder="Please select filing type"
                                value={fillingType}
                                options={[{ label: "Federal Filing", value: false }, { label: "State Filing", value: true }]}
                                onSelectCb={(name, selectedOption) => {
                                    dispatch(setFillingType(selectedOption))
                                    dispatch(setShouldGetSubmittedFormsGridData({
                                        gridData: true,
                                        updatePagination: true,
                                    }))

                                    if (selectedOption.value === "") {
                                        queryParams.delete("FilingType");
                                    }
                                    else if (selectedOption.value == true) {
                                        queryParams.set("FilingType", true);
                                    } else if (selectedOption.value == false) {
                                        queryParams.set("FilingType", false);
                                    }

                                    setQueryParams(queryParams);
                                }}
                            />

                            <div style={styles.filterContainerStyles}>
                                <TextInput
                                    name="recipientName"
                                    label='Search recipient by name'
                                    placeHolder='Enter recipient name'
                                    suffixProps={{
                                        icon: VEC_ICON_NAME.SEARCH_ICON,
                                        suffixIconCb: () => {
                                            dispatch(setShouldGetSubmittedFormsGridData({
                                                gridData: true,
                                                updatePagination: true,
                                            }))
                                            if (recipientName) {
                                                queryParams.set(QUERY_PARAMS.RECIPIENT_NAME, recipientName)
                                            } else {
                                                queryParams.delete(QUERY_PARAMS.RECIPIENT_NAME)
                                            }

                                            setQueryParams(queryParams)
                                        }
                                    }}
                                    value={recipientName}
                                    onChangeCb={(e) => dispatch(setRecipientName(e.target.value))}
                                />
                            </div>

                            <div style={styles.filterContainerStyles}>
                                <TextInput
                                    name="recipientTIN"
                                    label='Search recipient by tax id'
                                    placeHolder='Enter recipient tax id'
                                    suffixProps={{
                                        icon: VEC_ICON_NAME.SEARCH_ICON,
                                        suffixIconCb: () => {
                                            dispatch(setShouldGetSubmittedFormsGridData({
                                                gridData: true,
                                                updatePagination: true,
                                            }))
                                            if (recipientTIN) {
                                                queryParams.set(QUERY_PARAMS.RECIPIENT_ID, recipientTIN)
                                            } else {
                                                queryParams.delete(QUERY_PARAMS.RECIPIENT_ID)
                                            }

                                            setQueryParams(queryParams)
                                        }
                                    }}
                                    value={recipientTIN}
                                    onChangeCb={(e) => dispatch(setRecipientTIN(e.target.value))}
                                />
                            </div>
                        </div >
                    </>
                </div>
            </div>
        </>
    )
}